import { useMemo } from 'react';
import { useCurrentUser } from './useCurrentUser';
export var useCanEditProject = function(project) {
    var user = useCurrentUser().user;
    var canEdit = useMemo(function() {
        if (!user || !project) return false;
        var is_ops = user.is_ops, _user_organization_membership = user.organization_membership, is_admin = _user_organization_membership.is_admin, is_active = _user_organization_membership.is_active, is_customer_success = _user_organization_membership.is_customer_success;
        if (project.is_managed && !is_customer_success) return false;
        if (!is_active) return false;
        if (!!is_ops || is_admin) return true;
        if (project.user_id === user.id) return true;
        return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(project)
    ]);
    return {
        canEdit: canEdit
    };
};
